export const themeOverWrites = () => ({
  root: {
    flexGrow: 1,
  },
  emoji: {
    marginRight: '10px',
  },
})
